<template>
  <div class="mt-2">
    <base-input-primary-button
      label="Search"
      icon="mdi-magnify"
      @click="search"/>
    <base-input-secondary-button
      label="Reset"
      icon="mdi-close"
      @click="reset"/>
  </div>
</template>

<script>
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'
import BaseInputSecondaryButton from '@/base/input/BaseInputSecondaryButton'
export default {
  name: 'BaseInputSearchAndClearButtons',
  components: {
    BaseInputSecondaryButton,
    BaseInputPrimaryButton
  },
  methods: {
    search () {
      this.$emit('search')
    },
    reset () {
      this.$emit('reset')
    }
  }
}
</script>

<style scoped>

</style>
